// nav selection types
export const AGENCY_CHAT = "agency_chat";
export const VIEW_RESUME = "view_resume";
export const VIEW_RESPONSES = "view_responses";
export const EVENT_HISTORY = "event_history";
export const HIRE_DETAILS = "hire_details";
